<template>

	<div class="control is-horizontal">
		<div class="control-label">
			<label-name labelKey="SITE-APOPOINT-BNUMS"></label-name>
		</div>

		<div class="control">

			<multiselect
					v-if="!isLoading"
					v-model="selectedPharmacies"
					:options="pharmacies"
					:allow-empty="true"
					:multiple="true"
					:searchable="true"
					:loading="isSearching"
			    :internal-search="falses"
			    :clear-on-select="true"
			    :close-on-select="true"
			    :max-height="600"
			    :show-no-results="true"
			    :hide-selected="true"
					:customLabel="customPharmacyLabel"
					@input="$emit('input', $event)"
			    @search-change="asyncFind"
					selected-label="aktiv"
					deselect-label="Klick um abzuwählen"
					select-label="Klick für Auswahl"
					placeholder="Nach Apotheken suchen"
					track-by="nightDutySite"

					style="max-width: 450px;" class="small">

            <span slot="noOptions">Keine Einträge vorhanden</span>
            <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>

			</multiselect>

		</div>

	</div>

</template>



<script>
import Multiselect from 'vue-multiselect'


export default {

  name: 'xxx',

  props: {

    siteID: {
      type: Number,
      default: null,
      required: true
    },

  },

  components: {
    Multiselect
  },

  data() {

    return {
      isSearching: false,
      isLoading: true,
      selectedPharmacies: [],
      pharmacies: [],
    }

  },

  created() {

    this.fetchData();

  },

  methods: {

    async fetchData() {

      const res = await this.axios.get(`${this.$config.api}site/${this.siteID}?include=site.nightDutySites,siteNightDutySite.nightDutySite&fields=site,nightDutySites,nightDutySite,name,id,extRef,zipcode,apothekerkammerId`);

      res.data.nightDutySites.forEach((s) => {

        this.selectedPharmacies.push({
          id: s.id,
          name: s.nightDutySite.name,
          zipcode: s.nightDutySite.zipcode,
          nightDutySite: s.nightDutySite.id,
          site: s.site
        })

      })

      this.isLoading = false;

    },

    customPharmacyLabel({
      name,
      zipcode = null
    }) {
      return `${name} (PLZ ${zipcode})`;
    },

    closeDropdown(value, id) {
      this.isSearching = false;
    },

    limitText(count) {
      return `and ${count} other countries`
    },

    _debounceTimeout: null,

    async asyncFind(query) {
      if (query == "" || query.length < 3) {
        return;
      }
      if (this._debounceTimeout) {
        clearTimeout(this._debounceTimeout);
      }
      this._debounceTimeout = setTimeout(() => {
        this._asyncFind(query);
      }, 400);
    },

    async _asyncFind(query) {
      this.isSearching = true;
      this.pharmacies = [];
      const searchRes = await this.axios.get(`${this.$config.api}site?include=site.nightDutySites&fields=site,nightDutySites,nightDutySite,name,id,extRef,zipcode,apothekerkammerId&search=${query}&searchFields=name,extRef,zipcode`);
      const resFiltered = searchRes.data.site.filter((s) => s.apothekerkammerId != null && s.id != this.siteID);
      resFiltered.forEach((s) => {
        this.pharmacies.push({
          site: this.siteID,
          name: s.name,
          zipcode: s.zipcode,
          nightDutySite: s.id
        });
      });
      this.isSearching = false;
    },


  }

}
</script>
